import axios, { Axios, AxiosResponse } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import apiUrl from "../constants/apiUrl";
import { SCHOLARSHIP_FORM, CREATE_SCHOLARSHIP_FORM } from "../@types";
import api from "../config/apiClient";

const baseApiUrl = `${apiUrl}/scholarship-form/`;

export const GET_SCHOLARSHIPS = "GET_SCHOLARSHIP_FORMS";
export const getScholarships = createAsyncThunk(GET_SCHOLARSHIPS, async () => {
  const res: AxiosResponse = await api.get(baseApiUrl);
  return res.data;
});

export const CREATE_SCHOLARSHIP = "CREATE_SCHOLARSHIP";
export const createScholarship = createAsyncThunk(
  CREATE_SCHOLARSHIP,
  async (scholarshipData: CREATE_SCHOLARSHIP_FORM, { rejectWithValue }) => {
    try {
      const res: AxiosResponse = await api.post(
        `${baseApiUrl}`,
        scholarshipData
      );
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const DELETE_SCHOLARSHIP = "DELETE_SCHOLARSHIP";
export const deleteScholarship = createAsyncThunk(
  DELETE_SCHOLARSHIP,
  async (ScholarshipId: number | string, { rejectWithValue }) => {
    try {
      await api.delete(`${baseApiUrl}${ScholarshipId}/`, {});
      return ScholarshipId;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const EDIT_SCHOLARSHIP = "EDIT_SCHOLARSHIP";
export const editScholarship = createAsyncThunk(
  EDIT_SCHOLARSHIP,
  async (ScholarshipToEdit: SCHOLARSHIP_FORM, { rejectWithValue }) => {
    try {
      const { id, ...ScholarshipDataToSend } = ScholarshipToEdit;
      await api.put(`${baseApiUrl}${id}/`, ScholarshipDataToSend);
      return ScholarshipToEdit;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const GET_SCHOLARSHIP = "GET_SCHOLARSHIP";
export const getScholarship = createAsyncThunk(
  GET_SCHOLARSHIP,
  async (id: string | number, { rejectWithValue }) => {
    try {
      const res: AxiosResponse = await api.get(`${baseApiUrl}${id}/`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const clearScholarships = createAsyncThunk(
  "CLEAR_SCHOLARSHIPS",
  async () => null
);
